export const galleryItems = [
  {
    id: 1,
    room: 'Living Room',
    title: 'Meridian Sectional in Ivory',
    location: 'Henderson, NV',
    image: 'https://public.readdy.ai/ai/img_res/f77970c7d88676f85cca915244813bd4.jpg',
  },
  {
    id: 2,
    room: 'Bedroom',
    title: 'Oslo Suite in Blush',
    location: 'Summerlin, NV',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20master%20bedroom%20upholstered%20bed%20frame%20neutral%20linen%20warm%20bedding%20soft%20ambient%20lighting%20modern%20minimal%20design%20wood%20floors%20panoramic%20view%20elegant%20residential%20interior&width=700&height=520&seq=gal2&orientation=landscape',
  },
  {
    id: 3,
    room: 'Dining Room',
    title: 'Navarra Table for Eight',
    location: 'Las Vegas, NV',
    image: 'https://readdy.ai/api/search-image?query=elegant%20dining%20room%20setup%20solid%20wood%20dining%20table%20upholstered%20chairs%20pendant%20chandelier%20warm%20atmospheric%20lighting%20sophisticated%20neutral%20decor%20beautiful%20interior%20photography%20tall&width=600&height=760&seq=gal3&orientation=portrait',
  },
  {
    id: 4,
    room: 'Living Room',
    title: 'Como Chair Collection',
    location: 'Paradise, NV',
    image: 'https://readdy.ai/api/search-image?query=sophisticated%20living%20room%20with%20leather%20accent%20chairs%20sculptural%20modern%20fireplace%20warm%20wood%20floor%20ambient%20lighting%20minimal%20decor%20luxury%20interior%20design%20photography&width=700&height=500&seq=gal4&orientation=landscape',
  },
  {
    id: 5,
    room: 'Home Office',
    title: 'Summit Desk & Library',
    location: 'Green Valley, NV',
    image: 'https://readdy.ai/api/search-image?query=premium%20home%20office%20with%20solid%20wood%20executive%20desk%20built-in%20bookshelves%20leather%20chair%20sophisticated%20workspace%20warm%20library%20feel%20elegant%20interior%20design%20photography%20square&width=620&height=620&seq=gal5&orientation=squarish',
  },
  {
    id: 6,
    room: 'Outdoor',
    title: 'Riviera Patio Collection',
    location: 'Summerlin, NV',
    image: 'https://readdy.ai/api/search-image?query=luxury%20outdoor%20patio%20with%20premium%20rattan%20lounge%20furniture%20pool%20view%20warm%20afternoon%20light%20beautiful%20architecture%20sophisticated%20exterior%20design%20photography%20tall&width=600&height=780&seq=gal6&orientation=portrait',
  },
  {
    id: 7,
    room: 'Bedroom',
    title: 'Nordic Walnut Suite',
    location: 'Henderson, NV',
    image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20bedroom%20walnut%20furniture%20set%20nightstands%20dresser%20platform%20bed%20warm%20lighting%20wood%20floor%20clean%20sophisticated%20residential%20interior%20photography%20landscape&width=700&height=520&seq=gal7&orientation=landscape',
  },
  {
    id: 8,
    room: 'Dining Room',
    title: 'Alicante Round Dining',
    location: 'Las Vegas, NV',
    image: 'https://readdy.ai/api/search-image?query=beautiful%20round%20dining%20table%20with%20statement%20chairs%20open%20concept%20interior%20warm%20lighting%20high%20ceilings%20sophisticated%20elegant%20dining%20room%20interior%20design%20photography%20square&width=620&height=620&seq=gal8&orientation=squarish',
  },
];
